<form clrStepper [formGroup]="componentForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Komponente</clr-step-title>
    <clr-step-description>anhand Zeichnungsnummer {{ isUpdateMode ? 'bearbeiten' : 'eintragen' }}</clr-step-description>
    <clr-step-content>
      <clr-input-container>
        <label>Zeichnungsnummer</label>
        <input clrInput
               name="technical_drawing"
               formControlName="technical_drawing"
               (keyup)="onKeyUp($event)"
               [readonly]="isUpdateMode" />
        <clr-control-error *clrIfError="'maxLength'; error as err">Zeichnungsnummer zu lang (max. {{ err.technical_drawingLength}} Zeichen)</clr-control-error>
      </clr-input-container>
      <button *ngIf="!componentExists || isUpdateMode" clrStepButton="next">Weiter</button>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Beschreibung</clr-step-title>
    <clr-step-description>Detailinformationen zur {{ isUpdateMode ? 'bestehenden' : 'neuen' }} Komponente</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <clr-input-container>
        <label>Bezeichnung</label>
        <input clrInput formControlName="name" />
        <clr-control-error *clrIfError="'required'">Name der Komponente muss angegeben werden</clr-control-error>
      </clr-input-container>
      <clr-input-container>
        <label>Kurzbeschreibung</label>
        <input clrInput formControlName="description" />
      </clr-input-container>
      <clr-input-container>
        <label>Spezifikation</label>
        <input clrInput formControlName="specification" />
      </clr-input-container>
      <clr-select-container>
        <label>Material</label>
        <select clrSelect formControlName="material_id">
          <option [ngValue]="null">Bitte wählen…</option>
          <option *ngFor="let mat of materials" [ngValue]="mat.material_id">
            {{ mat.material }}
          </option>
        </select>
      </clr-select-container>
      <clr-input-container>
        <label>Hersteller</label>
        <input clrInput formControlName="manufacturer" />
      </clr-input-container>
      <clr-number-input-container>
        <label>Richtpreis (EUR/Stück)</label>
        <input clrNumberInput formControlName="guideline_price" type="number" min="0" step="0.01" />
      </clr-number-input-container>
      <clr-number-input-container>
        <label>Gewicht (in kg)</label>
        <input clrNumberInput formControlName="weight" type="number" />
      </clr-number-input-container>
      <clr-input-container>
        <label>Zolltarifnummer</label>
        <input clrInput formControlName="taric" />
      </clr-input-container>
      <!-- Beim Anlegen ist das eine echte Eingabe: sie erzeugt die
           Lagerbewegung "Initialisierung" (stock_init). -->
      <clr-number-input-container *ngIf="!isUpdateMode">
        <label>Lagerbestand (Warehouse)</label>
        <input clrNumberInput formControlName="number_of_pieces_in_stock" type="number" />
        <clr-control-helper>Anfangsbestand. Wird als Lagerbewegung gebucht.</clr-control-helper>
        <clr-control-error *clrIfError="'required'">Lagerbestand (Warehouse) muss angegeben werden (auch, wenn = 0)</clr-control-error>
      </clr-number-input-container>

      <!-- Beim Aendern nur Anzeige. Der Bestand ist die Summe der
           Lagerbewegungen und laesst sich ueber dieses Feld nicht setzen --
           frueher nahm es Eingaben entgegen, die stillschweigend verfielen. -->
      <clr-input-container *ngIf="isUpdateMode">
        <label>Lagerbestand (Warehouse)</label>
        <input clrInput type="text" readonly
               [value]="componentForm.get('stepII')?.get('number_of_pieces_in_stock')?.value ?? 0" />
        <clr-control-helper>Ergibt sich aus den Lagerbewegungen und kann hier nicht geaendert werden.</clr-control-helper>
      </clr-input-container>
      <clr-checkbox-container *ngIf="!componentForm.get('stepII')?.get('standard')?.value">
        <clr-checkbox-wrapper>
          <input type="checkbox" clrCheckbox formControlName="technology" />
          <label>Technologie</label>
        </clr-checkbox-wrapper>
        <clr-control-helper>Komponente als Verfahren (z.B. Schweißen, Glühen, Härten) kennzeichnen</clr-control-helper>
      </clr-checkbox-container>
      <clr-checkbox-container *ngIf="!componentForm.get('stepII')?.get('technology')?.value">
        <clr-checkbox-wrapper>
          <input type="checkbox" clrCheckbox formControlName="standard" />
          <label>Normteil</label>
        </clr-checkbox-wrapper>
        <clr-control-helper>Markieren, falls Komponente Normteil ist</clr-control-helper>
      </clr-checkbox-container>
      <clr-checkbox-container>
        <clr-checkbox-wrapper>
          <input type="checkbox" clrCheckbox formControlName="active" />
          <label>aktiv</label>
        </clr-checkbox-wrapper>
        <clr-control-helper>Deaktivieren, falls Komponente nicht mehr aktiv ist</clr-control-helper>
      </clr-checkbox-container>

      <button clrStepButton="next" [disabled]="componentForm.get('stepII')?.invalid">Weiter</button>
      <button clrStepButton="cancel" type="button" [routerLink]="['/component/overview/true']">Abbrechen</button>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Zeichnungen/Dokumente</clr-step-title>
    <clr-step-content *clrIfExpanded>
      <div class="alert alert-info" *ngIf="!isUpdateMode && !isCreatedInWizard">
        Bitte zuerst die Komponente speichern. Danach können die Dateien dieser Zeichnungsnummer sicher zugeordnet werden.
      </div>

      <div class="card" *ngIf="isUpdateMode || isCreatedInWizard">
        <div class="card-block">
          <div class="card-text">
            <app-component-files [componentID]="currentComponent || componentForm.get('stepI')?.get('technical_drawing')?.value"></app-component-files>
          </div>
        </div>
      </div>

      <div class="btn-group">
        <button class="btn btn-primary" [disabled]="isCreating" (click)="onSubmit()">
          {{ isUpdateMode ? 'Aktualisieren' : (isCreatedInWizard ? 'Fertig' : 'Komponente speichern') }}
        </button>
        <button class="btn btn-outline" type="button" [routerLink]="['/component/overview/true']">Abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>

<pre *ngIf="devMode">{{ componentForm.value | json }}</pre>
